import { TrainingListing, TrainingListingsApi, trainingListingsApi } from "api/TrainingListingApi";
import { Page } from "../../modules/Page";
import "./training-listing-page.scss";
import { debounce } from "modules/debounce";
import trainingListingsTemplate from "./TrainingListings.hbs";

type FilterState = {

    [FilterType.StringQuery]: string;
    [FilterType.Page]: number;
    [FilterType.Language]?: string;
};

type State = {
    trainingListings: TrainingListing[];
    filters: FilterState;
    totalTrainingListings: number;
    totalPages: number;
};

enum FilterType {
    StringQuery = "q",
    Page = "page",
    Language = "lang"
}

export interface TrainingListingsQueryParams {
    lang?: string
    page?: number; // default is 1
    q?: string;
    pageID?: string;

}

export class TrainingListingPage extends Page<typeof TrainingListingPage> {
    static readonly className = "js-training-listing-page";
    private loadMoreButton: HTMLButtonElement | null;
    private trainingListElement: HTMLElement;
    private pageID: string;

    private state: State = {
        trainingListings: [] as TrainingListing[],
        filters: {

            [FilterType.StringQuery]: "",
            [FilterType.Page]: 1,
        },
        totalTrainingListings: 0,
        totalPages: 0
    }

    constructor(
        rootElement: HTMLElement,
        index: number,
        private readonly api: TrainingListingsApi = trainingListingsApi,
    ) {
        super(rootElement, index);
        this.loadMoreButton = rootElement.querySelector<HTMLButtonElement>("#load-more-button")!;
        this.trainingListElement = rootElement.querySelector<HTMLElement>(".training__list .list__section")!;
        this.pageID = (this.rootElement.dataset.pageid || "0");

        this.refreshTrainingListings();
        this.loadMoreButton?.addEventListener("click", () => {
            this.loadNextPage();
        });
    }
    private getTrainingListingsHtml(trainingListings: TrainingListing[]) {
        return trainingListingsTemplate({
            trainingListings

        });
    }

    private getRequestParams() {
        const params: TrainingListingsQueryParams = {};

        params[FilterType.StringQuery] = this.state.filters[FilterType.StringQuery];
        params[FilterType.Page] = this.state.filters[FilterType.Page];

        // Add the language parameter
        if (this.state.filters[FilterType.Language]) {
            params.lang = this.state.filters[FilterType.Language];
        }

        if (this.pageID) {
            params.pageID = this.pageID;
        }

        return params;
    }

    private updateCountDisplay() {
        const showingCountElement = document.getElementById("showing-count");
        const totalCountElement = document.getElementById("total-count");

        if (showingCountElement) {
            const showingCount = this.state.trainingListings?.length;
            showingCountElement.textContent = showingCount !== undefined ? showingCount.toString() : "0";
        }

        if (totalCountElement) {
            const totalCount = this.state.totalTrainingListings;
            totalCountElement.textContent = totalCount !== undefined ? totalCount.toString() : "0";
        }
    }

    private refreshTrainingListings = debounce(async () => {
        this.state.filters[FilterType.Page] = 1;

        const params = this.getRequestParams();
        const trainingListingsPageData = await this.api.getTrainingListings(params);

        window.history.replaceState({}, "", `${window.location.pathname}?${new URLSearchParams(params as any)}`);

        this.state.totalTrainingListings = trainingListingsPageData.totalTrainingListings;
        this.state.totalPages = trainingListingsPageData.totalPages;
        this.state.trainingListings = trainingListingsPageData.trainingListings;

        this.trainingListElement.innerHTML = this.getTrainingListingsHtml(this.state.trainingListings);
        this.updateCountDisplay();

        if (this.loadMoreButton) {
            this.loadMoreButton.style.display = this.state.totalPages > 1 ? "block" : "none";
        }
    }, 500);

    private loadNextPage = debounce(async () => {
        this.state.filters[FilterType.Page] += 1;

        const params = this.getRequestParams();
        const trainingListingsPageData = await this.api.getTrainingListings(params);

        this.state.trainingListings.push(...trainingListingsPageData.trainingListings);
        this.trainingListElement.innerHTML += this.getTrainingListingsHtml(trainingListingsPageData.trainingListings);
        this.updateCountDisplay();

        if (this.loadMoreButton) {
            const showingCount = this.state.trainingListings.length;
            const totalCount = this.state.totalTrainingListings;

            this.loadMoreButton.style.display = showingCount >= totalCount ? "none" : "block";
        }
    });
}
